import React, { useState } from 'react';
import { X, Upload, Link, Calendar, Globe, Clock, Award, FileText, Users, Zap } from 'lucide-react';
import { Sprout, Microscope, Beaker, BookOpen } from 'lucide-react';
import API_URL from '../config/ApiUrl';
import { researchAPI } from '../services/ResearchServices';
import { useTheme } from '../arrangement/ThemeContext';
const SubmitResearchDialog = ({ isOpen, categories2, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    url: '',
    title: '',
    subtitle: '',
    author: '',
    institution: '',
    publishedDate: '',
    readTime: '',
    category: 'medical',
    type: 'research',
    tags: [],
    description: '',
    methodology: '',
    sampleSize: '',
    isPeerReviewed: false,
    sources: '',
    difficulty: 'intermediate'
  });
  const { colors } = useTheme();

  const [currentTag, setCurrentTag] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  console.log(categories2);
  console.log('CATEGORIES: ',categories2);

  const categories = [
    { id: 'all', name: 'All Research', icon: <Globe size={16} />, count: categories2?.reduce((sum, cat) => sum + cat.count, 0) || 247, color: '#8b5cf6', trending: true },
    { id: 'growing', name: 'Growing & Cultivation', icon: <Sprout size={16} />, count: categories2?.find(cat => cat.name === 'Growing & Cultivation')?.count || 89, color: '#10b981', new: 8 },
    { id: 'medical', name: 'Medical Research', icon: <Microscope size={16} />, count: categories2?.find(cat => cat.name === 'Medical Research')?.count || 78, color: '#3b82f6', hot: true },
    { id: 'strains', name: 'Strain Analysis', icon: <Beaker size={16} />, count: categories2?.find(cat => cat.name === 'Strain Analysis')?.count || 45, color: '#f59e0b', verified: true },
    { id: 'general', name: 'General Science', icon: <BookOpen size={16} />, count: categories2?.find(cat => cat.name === 'General Science')?.count || 35, color: '#ef4444', community: true }
  ];

  const difficulties = ['Beginner', 'Intermediate', 'Advanced', 'Expert'];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };


  const addTag = () => {
    if (currentTag.trim() && !formData.tags.includes(currentTag.trim())) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, currentTag.trim()]
      }));
      setCurrentTag('');
    }
  };

  const removeTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };

  const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
          // Make actual API call instead of simulation
          const result = await researchAPI.submitResearchArticle(formData);
          
          // Success! Pass the created article to parent component
          onSubmit(result.article);
          
          // Close dialog and reset form
          onClose();
          setFormData({
            url: '',
            title: '',
            subtitle: '',
            author: '',
            institution: '',
            publishedDate: '',
            readTime: '',
            category: 'medical',
            type: 'research',
            tags: [],
            description: '',
            methodology: '',
            sampleSize: '',
            isPeerReviewed: false,
            sources: '',
            difficulty: 'intermediate'
          });
          
          // Optional: Show success message
          alert('Research article submitted successfully! It is now pending review.');
          
        } catch (error) {
          console.error('Failed to submit research:', error);
          
          // Handle different error types
          if (error.message.includes('Validation failed')) {
            alert('Please check your form data and try again.');
          } else if (error.message.includes('already been submitted')) {
            alert('This URL has already been submitted. Please use a different article.');
          } else {
            alert('Failed to submit research article. Please try again.');
          }
        } finally {
          setIsSubmitting(false);
        }
      };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '24px',
        border: '1px solid #333',
        width: '100%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'hidden',
        boxShadow: '0 25px 60px rgba(0, 0, 0, 0.5)'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
          padding: '24px',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div>
            <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '700' }}>
              Submit Research Article
            </h2>
            <p style={{ margin: 0, opacity: 0.9, fontSize: '14px' }}>
              Share scientific studies and research with the cannabis community
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Form Content */}
        <div style={{
          padding: '32px',
          overflowY: 'auto',
          maxHeight: 'calc(90vh - 120px)',
          color: 'white'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div>
              <label style={{
                display: 'block',
                marginBottom: '12px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#e5e5e5'
              }}>
                Category *
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                {categories.filter(cat => cat.id !== 'all').map(cat => (
                  <div
                    key={cat.id}
                    onClick={() => handleInputChange('category', cat.id)}
                    style={{
                      padding: '16px',
                      background: formData.category === cat.id ? `${cat.color}20` : '#2a2a2a',
                      border: `2px solid ${formData.category === cat.id ? cat.color : '#333'}`,
                      borderRadius: '12px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <div style={{ color: cat.color }}>
                      {cat.icon}
                    </div>
                    <div>
                      <div style={{
                        color: formData.category === cat.id ? cat.color : '#e5e5e5',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        {cat.name}
                      </div>
                      <div style={{
                        color: '#888',
                        fontSize: '12px'
                      }}>
                        {cat.count} articles
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              </div>
            {/* URL Field */}
            <div>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#e5e5e5'
              }}>
                <Link size={16} style={{ color: '#3b82f6' }} />
                Research Article URL *
              </label>
              <input
                type="url"
                value={formData.url}
                onChange={(e) => handleInputChange('url', e.target.value)}
                placeholder="https://example.com/research-paper"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  background: colors.bgCard,
                  border: '1px solid #333',
                  borderRadius: '12px',
                  color: '#e5e5e5',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {/* Title and Subtitle */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  <FileText size={16} style={{ color: '#10b981' }} />
                  Article Title *
                </label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => handleInputChange('title', e.target.value)}
                  placeholder="Enter the research article title"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  Subtitle/Summary
                </label>
                <input
                  type="text"
                  value={formData.subtitle}
                  onChange={(e) => handleInputChange('subtitle', e.target.value)}
                  placeholder="Brief summary or key finding"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* Author and Institution */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  <Users size={16} style={{ color: '#8b5cf6' }} />
                  Lead Author *
                </label>
                <input
                  type="text"
                  value={formData.author}
                  onChange={(e) => handleInputChange('author', e.target.value)}
                  placeholder="Dr. Jane Smith"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  <Globe size={16} style={{ color: '#f59e0b' }} />
                  Institution *
                </label>
                <input
                  type="text"
                  value={formData.institution}
                  onChange={(e) => handleInputChange('institution', e.target.value)}
                  placeholder="University of Cannabis Research"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* Date and Read Time */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  <Calendar size={16} style={{ color: '#ef4444' }} />
                  Published Date *
                </label>
                <input
                  type="date"
                  value={formData.publishedDate}
                  onChange={(e) => handleInputChange('publishedDate', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  <Clock size={16} style={{ color: '#10b981' }} />
                  Read Time (minutes)
                </label>
                <input
                  type="number"
                  value={formData.readTime}
                  onChange={(e) => handleInputChange('readTime', e.target.value)}
                  placeholder="15"
                  min="1"
                  max="120"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* Category and Type */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  Difficulty Level
                </label>
                <select
                  value={formData.difficulty}
                  onChange={(e) => handleInputChange('difficulty', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                >
                  {difficulties.map(diff => (
                    <option key={diff} value={diff.toLowerCase()}>{diff}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Research Details */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  Methodology
                </label>
                <input
                  type="text"
                  value={formData.methodology}
                  onChange={(e) => handleInputChange('methodology', e.target.value)}
                  placeholder="RCT, Meta-analysis, etc."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  Sample Size
                </label>
                <input
                  type="text"
                  value={formData.sampleSize}
                  onChange={(e) => handleInputChange('sampleSize', e.target.value)}
                  placeholder="1,200 patients"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#e5e5e5'
                }}>
                  # Sources
                </label>
                <input
                  type="number"
                  value={formData.sources}
                  onChange={(e) => handleInputChange('sources', e.target.value)}
                  placeholder="45"
                  min="0"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* Tags */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#e5e5e5'
              }}>
                Research Tags
              </label>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                <input
                  type="text"
                  value={currentTag}
                  onChange={(e) => setCurrentTag(e.target.value)}
                  placeholder="Add a tag (e.g., CBD, Pain Management)"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      addTag();
                    }
                  }}
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#e5e5e5',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                />
                <button
                  type="button"
                  onClick={addTag}
                  style={{
                    padding: '12px 20px',
                    background: 'linear-gradient(135deg, #10b981 0%, #00d4aa 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  Add
                </button>
              </div>
              
              {formData.tags.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {formData.tags.map(tag => (
                    <span
                      key={tag}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '6px 12px',
                        background: '#00d4aa20',
                        color: '#00d4aa',
                        borderRadius: '8px',
                        fontSize: '12px',
                        fontWeight: '500'
                      }}
                    >
                      #{tag}
                      <button
                        type="button"
                        onClick={() => removeTag(tag)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#00d4aa',
                          cursor: 'pointer',
                          padding: 0,
                          marginLeft: '4px'
                        }}
                      >
                        <X size={12} />
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Description */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#e5e5e5'
              }}>
                Research Description
              </label>
              <textarea
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                placeholder="Provide a detailed description of the research findings, methodology, and significance..."
                rows={4}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  background: colors.bgCard,
                  border: '1px solid #333',
                  borderRadius: '12px',
                  color: '#e5e5e5',
                  fontSize: '14px',
                  outline: 'none',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {/* Peer Reviewed Checkbox */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '16px',
              background: colors.bgCard,
              borderRadius: '12px',
              border: '1px solid #333'
            }}>
              <input
                type="checkbox"
                id="peerReviewed"
                checked={formData.isPeerReviewed}
                onChange={(e) => handleInputChange('isPeerReviewed', e.target.checked)}
                style={{
                  width: '18px',
                  height: '18px',
                  accentColor: '#fbbf24'
                }}
              />
              <label htmlFor="peerReviewed" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                fontWeight: '500',
                color: '#e5e5e5',
                cursor: 'pointer'
              }}>
                <Award size={16} style={{ color: '#fbbf24' }} />
                This research is peer-reviewed
              </label>
            </div>

            {/* Submit Button */}
            <div style={{ display: 'flex', gap: '12px', paddingTop: '16px' }}>
              <button
                type="button"
                onClick={onClose}
                style={{
                  flex: 1,
                  padding: '16px',
                  background: 'transparent',
                  color: '#888',
                  border: '1px solid #333',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '500'
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isSubmitting}
                style={{
                  flex: 2,
                  padding: '16px',
                  background: isSubmitting 
                    ? 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)'
                    : 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                {isSubmitting ? (
                  <>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #ffffff40',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    Submitting...
                  </>
                ) : (
                  <>
                    <Upload size={16} />
                    Submit Research
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default SubmitResearchDialog;